import { Form } from 'common/form';
import { EditCandidate, editCandidateForm } from '../forms/editCandidateForm';
import { ToastType, useToast } from 'services/toast';
import { Link, Typography } from '@mui/material';
import { useDrawerV2 } from 'common/drawer/hooks/useDrawerV2';
import { CandidatesByCandidateBatchItem } from '../types/CandidatesByCandidateBatch';
import { formatPhoneNumber } from 'utils/phoneNumbers';
import { useUpdateCandidateMutation } from 'generated-graphql/hooks/apollo-hooks';

export const EditCandidateDetails: React.FC<{
  candidate: CandidatesByCandidateBatchItem;
}> = ({ candidate }) => {
  const { closeDrawer: closeDrawerV2 } = useDrawerV2();
  const { showToast } = useToast();

  const [updateCandidate] = useUpdateCandidateMutation({
    onCompleted: () => {
      showToast({
        type: ToastType.Success,
        title: 'Candidate details updated'
      });
      closeDrawerV2();
    }
  });

  const handleSubmit = async (values: EditCandidate) => {
    try {
      await updateCandidate({
        variables: {
          input: {
            id: candidate.id,
            ...values,
            phoneNumber: formatPhoneNumber(values.phoneNumber)?.number
          }
        }
      });
    } catch (error) {
      console.error(error);
      showToast({
        type: ToastType.Error,
        title: 'Something went wrong',
        message: (
          <Typography variant="body2" mt={1}>
            Try updating these details again.{' '}
            <Link href="mailto:support@joinpopp.com?subject=Failed to update conversation">
              contact support
            </Link>{' '}
            if the issue persists.
          </Typography>
        )
      });
    }
  };

  return (
    <Form
      schema={editCandidateForm.schema}
      fields={editCandidateForm.fields}
      submitButtonProps={{
        label: 'Confirm'
      }}
      defaultValues={{
        firstName: candidate.firstName,
        lastName: candidate.lastName,
        email: candidate.email,
        phoneNumber: candidate.phoneNumber
      }}
      onCancel={() => closeDrawerV2()}
      onSubmit={handleSubmit}
    />
  );
};
